'use client';

import { useEffect, useState } from 'react';

let cache: { isAdmin: boolean } | null = null;
let inflight: Promise<boolean> | null = null;

export function clearAdminModeCache() {
  cache = null;
  inflight = null;
}

function fetchAdminStatus(): Promise<boolean> {
  if (cache !== null) return Promise.resolve(cache.isAdmin);
  if (!inflight) {
    inflight = fetch('/api/admin/auth/check', { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : { authenticated: false }))
      .then((d: { authenticated?: boolean }) => {
        cache = { isAdmin: !!d.authenticated };
        return cache.isAdmin;
      })
      .catch(() => {
        cache = { isAdmin: false };
        return false;
      });
  }
  return inflight;
}

export function useAdminMode() {
  // 첫 렌더는 항상 비관리자(false)로 시작 → 서버 SSR(항상 false)과 클라이언트 하이드레이션이 일치.
  // 모듈 캐시(cache)가 이미 true 여도 초기값으로 쓰지 않는다 (쓰면 하이드레이션 className 불일치 발생).
  // 마운트 후 useEffect 에서 캐시/조회 결과로 갱신.
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(cache === null);

  useEffect(() => {
    let cancelled = false;
    if (cache !== null) {
      setIsAdmin(cache.isAdmin);
      setLoading(false);
      return;
    }
    fetchAdminStatus().then((v) => {
      if (cancelled) return;
      setIsAdmin(v);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { isAdmin, loading };
}
